import { motion } from "framer-motion";
import { ArrowUpRight, Phone, Eye } from "@phosphor-icons/react";

export default function ClosingCTA() {
  return (
    <section
      data-testid="closing-cta"
      className="relative py-20 sm:py-28 md:py-32 bg-[#0a0a0b] overflow-hidden"
    >
      <div className="absolute inset-0 hero-glow pointer-events-none" />
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-60" />
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 flex flex-col items-center text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-[18ch] font-display font-bold text-[36px] sm:text-5xl lg:text-[68px] leading-[1.0] tracking-tighter text-white"
        >
          Ready to get found — and <span className="text-brand-400">answer first?</span>
        </motion.h2>
        <p className="mt-6 max-w-xl text-[15.5px] sm:text-lg text-zinc-300 leading-relaxed">
          Tell us what you need. We reply within one business day with plain-English next steps and exact pricing — no sales call required.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <a
            href="#contact"
            data-testid="closing-cta-inquiry"
            className="group inline-flex items-center justify-center gap-3 pl-7 pr-2 py-2 rounded-full bg-white text-black font-medium hover:bg-zinc-200 transition-colors"
          >
            Send an inquiry
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-brand-600 text-white transition-transform group-hover:translate-x-0.5">
              <ArrowUpRight size={16} weight="bold" />
            </span>
          </a>
          <a
            href="tel:6023905623"
            data-testid="closing-cta-call"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-white/15 bg-white/[0.03] text-white font-medium hover:bg-brand-700/25 hover:border-brand-500/50 transition-colors"
          >
            <Phone size={17} weight="regular" />
            Call 602-390-5623
          </a>
          <a
            href="#work"
            data-testid="closing-cta-work"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-zinc-300 hover:text-white transition-colors"
          >
            <Eye size={17} weight="regular" />
            See live client sites
          </a>
        </div>
      </div>
    </section>
  );
}
